import { useState, useEffect, useRef } from "react";

interface CountdownValues {
  hours: number;
  minutes: number;
  seconds: number;
}

export function useCountdown(targetTime: Date | null): CountdownValues {
  const [totalSeconds, setTotalSeconds] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!targetTime) return;

    function tick() {
      const diff = Math.max(
        0,
        Math.floor((targetTime!.getTime() - Date.now()) / 1000)
      );
      setTotalSeconds(diff);
    }

    tick();
    intervalRef.current = setInterval(tick, 1000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [targetTime]);

  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}
